import { renderTokenCell } from '../TokenCell';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderOwnersCell = (data: any) => renderTokenCell(data, 'name');
